"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-youtube/~/youtube-player/dist/constants/PlayerStates.js
 ** module id = 3633
 ** module chunks = 0
 **/